import React from 'react';
import { Link } from 'react-router-dom';

export default function Dashboard() {
  const items = [
    { name: 'Services', path: '/services' },
    { name: 'Groupes', path: '/groupes' },
    { name: 'Familles', path: '/familles' },
    { name: 'Bénéficiaires', path: '/beneficiaires' },
    { name: 'Contacts', path: '/contacts' },
  ];

  return (
    <div className="p-8 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center">Tableau de Bord</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {items.map(item => (
          <Link key={item.path} to={item.path} className="bg-white border shadow hover:shadow-lg transition rounded-xl p-6 text-center dark:bg-gray-800 dark:text-white">
            <h2 className="text-xl font-semibold mb-2">{item.name}</h2>
            <p className="text-sm text-gray-600 dark:text-gray-300">Gérer les {item.name.toLowerCase()}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}